import { Pipe, PipeTransform } from '@angular/core';
import { Nullable } from '@markant-platform/shared/util-helpers';

@Pipe({
  name: 'defaultValue',
  standalone: true,
})
export class DefaultValuePipe implements PipeTransform {
  transform(value: Nullable<string>, defaultValue = ''): string {
    return value ? value : defaultValue;
  }
}
